export default function Twitter() {
  return (
    <>
      <path
        d="M22.5001 43.6765C10.5284 43.6765 0.823471 33.9716 0.823471 21.9999C0.823471 10.0282 10.5284 0.323242 22.5001 0.323242C34.4718 0.323242 44.1768 10.0282 44.1768 21.9999C44.1768 33.9716 34.4718 43.6765 22.5001 43.6765Z"
        fill="currentColor"
      />
      <path
        d="M35.853 9.44105L25.4918 23.2947L35.9183 34.5584H33.5715L24.4429 24.6966L17.0675 34.5584H9.08197L20.0263 19.9256L10.3213 9.44105H12.6681L21.0748 18.5232L27.8674 9.44105H35.853ZM32.4019 11.1695H28.7334L12.5334 32.8299H16.202L32.4019 11.1695Z"
        fill="#02122B"
      />
    </>
  );
}
